module.exports = __webpack_public_path__ + "static/media/marginalia-boat.fd51c4af.png";